import { QueryCollection } from '@shared/models/query-collection';
import { ActiveRuleResponse, EvaluationResponse } from 'src/app/web-api-client';
import { EvaluationQuestion } from './evaluation-question';
import { EvaluationTaxResult } from './evaluation-tax-result';

export class RulesForm {
  activeRule?: ActiveRuleResponse;
  data?: EvaluationResponse;
  questions: QueryCollection<EvaluationQuestion> =
    new QueryCollection<EvaluationQuestion>([]);
  taxResults: QueryCollection<EvaluationTaxResult> =
    new QueryCollection<EvaluationTaxResult>([]);
  isCompleted: boolean = false;

  constructor(activeRule?: ActiveRuleResponse) {
    this.activeRule = activeRule;
    this.data = undefined;
  }
}
